import _ from 'lodash';
import PropTypes from 'prop-types';
import { Image } from '../shared';
import useResponsive from '../../../utils/responsive';


const CommercialRentalSection = (props) => {
    const {
        title,
        paragraph,
        imgSrc,
        imgAlt,
        paragraphTitle,
        paragraphText,
        icons,
    } = props;
    
    const { isMobile, isTablet } = useResponsive();
    const isSmallScreen = isMobile || isTablet;    

    const renderImageSection = () => {
        return (
            <div>
                {isSmallScreen && <p className='dummy-header-two' style={{ marginBottom: 30 }}>{paragraphTitle}</p>}
                <Image src={imgSrc} alt={imgAlt} isOldImage className="general-image" />
            </div>
        );
    };

    const renderTextSection = () => {
        return (
            <div>
                {!isSmallScreen && <p className='dummy-header-two' style={{ marginBottom: 30 }}>{paragraphTitle}</p>}
                <p className='commerical-rental-section-paragraph-text'>{paragraphText}</p>
                {renderIcons()}
            </div>
        );
    };

    const renderIcons = () => {
        return icons.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <div className='commerical-rental-section-icon-and-text-container' key={index}>
                    <div className='commerical-rental-section-icon-container'>
                        <Image src={iconSrc} alt="" isOldImage />
                    </div>
                    <div>
                        <h5>{iconTitle}</h5>
                        <p className='commerical-rental-section-icon-paragraph'>{iconParagraph}</p>
                    </div>
                </div>
            );
        });
    };

    return (

        <div className='container-root container-root-maxWidthLg' id="commercial-rental">

            <div className='commerical-rental-section-intro-section'>
                <p className='dummy-header-two' style={{ marginBottom: 24 }}>{title}</p>
                <p className='commerical-rental-section-section-paragraph'>{paragraph}</p>
            </div>

            <div className='main-grid-container main-grid-spacing-xs-3 commerical-rental-section-grid-container'>

                <div className='main-grid-item main-grid-md-6 main-adjust-width-grid'>
                    {renderImageSection()}
                </div>

                <div className='main-grid-item main-grid-md-6'>
                    {renderTextSection()}
                </div>

            </div>

        </div>

    );
};

export default CommercialRentalSection;

CommercialRentalSection.propTypes = {
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
    paragraphTitle: PropTypes.string,
    paragraphText: PropTypes.string,
};
